class RouteRules {
  static RouteAlwaysAllowed = (): boolean => true;

  static IsUserLoggedIn = (user: ICognitoUser | undefined): boolean => {
    return user?.signInUserSession?.accessToken?.jwtToken?.length ? true : false;
  };

  static IsSignedInAndAcceptedTOS = (userObj: ICognitoUser | undefined): boolean =>
    RouteRules.IsUserLoggedIn(userObj) && userObj?.attributes?.['custom:tos-accepted'] === 'true';

  static IsAdminUser = (user: ICognitoUser | undefined): boolean => {
    return (
      user?.signInUserSession?.accessToken?.payload &&
      user.signInUserSession.accessToken.payload['cognito:groups']?.some((x: string) => x === 'admins')
    );
  };

  static GetUserIdTokenInfo = (user: any | undefined , key:string) => {
    return  user?.signInUserSession?.idToken?.payload?.[key];
  };

  static IsSignedInAndSavedPreferences = (userObj: ICognitoUser | undefined): boolean =>
    RouteRules.IsUserLoggedIn(userObj) && userObj?.attributes?.['custom:preferences-saved'] === 'true';
}

export { RouteRules };
